<div
  class="border-t-borderColor pt-6 tablet:pt-8 desktop:pt-9 border-t mt-4 tablet:mt-5 desktop:mt-6"
>
  <ng-content></ng-content>
</div>
